<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">SV thôi học ngừng học</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm" (click)="bienDongSV()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Biến động sinh viên</button>
                <button class="btn btn-info btn-sm" (click)="siSoTheoHe()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Sĩ số sv theo hệ</button>
                <button class="btn btn-info btn-sm" (click)="siSoTheoKhoa()"
                    style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Sĩ số sv theo khoa</button>
                <button class="btn btn-info btn-sm" (click)="siSoTheoNganh()"
                    style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Sĩ số sv theo ngành</button>
                <button class="btn btn-info btn-sm" (click)="siSoTheoLop()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i>Sĩ số sv theo lớp
                </button>
                <button class="btn btn-warning btn-sm"  type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky">
                            <option value="">Tất cả</option>
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplayBDSV">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr *ngFor="let i of headBienDongSV">
                            <th *ngFor="let value of i.Cells" [attr.colspan]="value.Colspan"
                                [attr.rowspan]="value.Rowspan">
                                {{value.Name}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of dataBienDongSV">

                            <td *ngFor="let value of i.Value"
                                [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}">
                                {{value.Value}}
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplaySSTheoHe">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Khóa</th>
                            <th>Số lượng</th>
                            <th>Dừng HT</th>
                            <th>Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let value of dataSiSoTheoHe.Data; index as i">
                            <td style="text-align:center;">{{i+1}}</td>
                            <td style="text-align:center;">{{value.Khoa}} </td>
                            <td style="text-align:center;">{{value.So_luong}} </td>
                            <td style="text-align:center;">{{value.DungHT}} </td>
                            <td style="text-align:center;">{{value.Ghi_chu}}:lớp </td>
                        </tr>
                        <tr >
                            <td colspan="2" style="font-weight: bold;">Tổng số</td>
                            <td style="text-align:center;font-weight: bold;">{{dataSiSoTheoHe.Tong_so_so_luong}} </td>
                            <td style="text-align:center;font-weight: bold;">{{dataSiSoTheoHe.Tong_so_dung_ht}} </td>
                            <td style="text-align:center;font-weight: bold;">{{dataSiSoTheoHe.Tong_so_ghi_chu}} </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplaySSTheoKhoa">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Lớp</th>
                            <th>Sĩ số</th>
                            <th>Dừng học</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let value of dataSiSoTheoKhoa;">
                            <tr>
                                <td  style="margin-left: 5px; font-weight: bold;font-size: 17px;">Khoa:
                                    {{value.Ten_khoa}}</td>
                                <td  style="margin-left: 5px; font-weight: bold;font-size: 17px;">Tổng số:
                                    {{value.Tong_so}}</td>
                                <td  style="margin-left: 5px; font-weight: bold;font-size: 17px;">Tổng số:
                                    {{value.Tong_so_dung}}</td>
                            </tr>
                            <tr *ngFor="let element of value.SiSoModel">
                                <td>{{element.Ten_lop}}</td>
                                <td>{{element.Si_so}}</td>
                                <td>{{element.Dung_hoc}}</td>
                            </tr>
                            <!-- <tr>
                                <td colspan="2" style="margin-left: 5px; font-weight: bold;font-size: 17px;">Tổng số:
                                    {{value.Tong_so}}</td>
                            </tr> -->
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplaySSTheoNganh">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Lớp</th>
                            <th>Sĩ số</th>
                            <th>Dừng học</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let value of dataSiSoTheoNganh;">
                            <tr>
                                <td style="margin-left: 5px; font-weight: bold;font-size: 17px; color: red;">
                                    Ngành: {{value.Ten_nganh}}</td>
                                <td  style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px; color: red;">
                                    Tổng sv ngành: {{value.Tong_so}}</td>
                                <td  style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px; color: red;">
                                    Tổng sv dừng học theo ngành: {{value.Tong_so_dung_hoc}}</td>
                            </tr>
                            <ng-container *ngFor="let element of value.ChuyenNganhData;">
                                <tr>
                                    <td  style="margin-left: 5px; font-weight: bold;font-size: 17px;">
                                        Chuyên ngành: {{element.Ten_chuyen_nganh}}</td>
                                    <td  style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px;">
                                        Tổng sv chuyên ngành: {{element.Tong_so}}</td>
                                    <td  style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px;">
                                        Tổng sv dừng học theo chuyên ngành: {{element.Tong_so_dung_hoc}}</td>
                                </tr>
                                <tr *ngFor="let i of element.SiSoModel">
                                    <td>{{i.Ten_lop}}</td>
                                    <td style="text-align: center">{{i.Si_so}}</td>
                                    <td style="text-align: center">{{i.Dung_hoc}}</td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="2" style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px;">
                                        Tổng sv chuyên ngành: {{element.Tong_so}}</td>
                                </tr> -->
                            </ng-container>
                            <!-- <tr>
                                <td colspan="2" style="text-align: center;margin-left: 5px; font-weight: bold;font-size: 17px; color: red;">
                                    Tổng sv ngành: {{value.Tong_so}}</td>
                            </tr> -->

                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplaySSTheoLop">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Lớp</th>
                            <th>Số sinh viên</th>
                            <th>Dừng học</th>

                        </tr>
                    </thead>
                    <tbody>
                            <tr  *ngFor="let value of dataSiSoTheoLop;">
                               <td>{{value.Ten_lop}}</td>
                               <td>{{value.So_sv}}</td>
                               <td>{{value.So_sv_dung}}</td>
                            </tr>
                          
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>